import React from "react";

const inr = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0,
});

function one(n) {
  return Number.isFinite(n) && n > 0 ? inr.format(n) : null;
}

/**
 * Formats a price in Indian Rupees.
 * Accepts a number, a numeric string, or a range such as "33049-45434".
 */
export function formatINR(value) {
  if (value === null || value === undefined) return "Price on request";

  const raw = String(value).trim();

  // Range: "33049-45434" or "33049 - 45434"
  const range = raw.match(/^(\d[\d,.]*)\s*[-–—]\s*(\d[\d,.]*)$/);
  if (range) {
    const lo = one(Number(range[1].replace(/,/g, "")));
    const hi = one(Number(range[2].replace(/,/g, "")));
    if (lo && hi) return `${lo} – ${hi}`;
  }

  const n = Number(raw.replace(/[^0-9.]/g, ""));
  return one(n) || "Price on request";
}

export default function Price({ value, note = true, className = "" }) {
  return (
    <>
      <p className={`rg-price ${className}`}>{formatINR(value)}</p>
      {note && (
        <p className="rg-price-note">
          INR, inclusive of GST. Delivery charges extra where applicable.
        </p>
      )}
    </>
  );
}
